import React, { useEffect } from "react";

import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const ReactGridLayout = WidthProvider(Responsive);

const GridLayoutDragDrop = ({ rowHeight, layouts, children, onDragEnd, noOfItemPerCol, isDashboardPanelOpened }) => {
  const breakpoints = { lg: 1200 };
  const cols = { lg: noOfItemPerCol };

  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 10);
  }, [isDashboardPanelOpened]);

  return (
    <ReactGridLayout
      className="layout"
      layouts={{ lg: layouts }}
      breakpoints={breakpoints}
      cols={cols}
      rowHeight={rowHeight}
      onDragStop={onDragEnd}
      resizeHandle={false}
      compactType={"vertical"}
      isBounded={true}
    >
      {children}
    </ReactGridLayout>
  );
};

export default GridLayoutDragDrop;
